//@flow

import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';

import styles from './RewardsDashboardHeader.scss';

import type { RewardsDashboardHeader_tradeFirm as TradeFirm } from './__generated__/RewardsDashboardHeader_tradeFirm.graphql';

type RewardsDashboardHeaderProps = {|
    tradeFirm: TradeFirm,
|};

export function RewardsDashboardHeaderComponent({ tradeFirm }: RewardsDashboardHeaderProps) {
    const { name } = tradeFirm;

    return (
        <div className={styles.wrapper}>
            <h1 className={styles.header}>
                <FormattedMessage
                    id="abt.RewardsDashboardHeader.header"
                    defaultMessage="Trade Rewards"
                />
            </h1>
            <div className={styles.welcomeMessage}>
                <FormattedMessage
                    id="abt.RewardsDashboardHeader.welcomeMessage"
                    defaultMessage="Welcome, {name}!"
                    values={{ name }}
                />
            </div>
        </div>
    );
}

export const RewardsDashboardHeader = createFragmentContainer(RewardsDashboardHeaderComponent, {
    tradeFirm: graphql`
        fragment RewardsDashboardHeader_tradeFirm on TradeFirmType {
            name
        }
    `,
});
